import React from 'react'
import Icon from '../elements/Icon/Icon'


const Payway = (props) => {

    const { paywayCode, selected } = props

    switch (paywayCode.toString().toUpperCase()) {
        case 'VISA_MC_P2P':
            return (
                <div>
                    {selected ?
                        <Icon icon={'VISAMCSELECT'} size={90} /> :
                        <Icon icon={'VISAMC'} size={40} />}
                </div>
            )
        case 'VISA_MC_WW':
            return (
                <div>
                    {selected ?
                        <Icon icon={'VISAMCSELECT'} size={90} /> :
                        <Icon icon={'VISAMC'} size={40} />}
                </div>
            )
        case 'VISA_MC':
            return (
                <div>
                    {selected ?
                        <Icon icon={'VISAMCSELECT'} size={90} /> :
                        <Icon icon={'VISAMC'} size={40} />}
                </div>
            )
        case 'MOBILE_PHONE':
            return (
                <div>
                    {selected ?
                        <Icon icon={'MOBILESELECT'} size={40} /> :
                        <Icon icon={'MOBILE'} size={40} />}
                </div>
            )
        case 'QIWI':
            return (
                <div>
                    <Icon icon={'QIWI'} color={selected ? '#404040' : ''} size={36} />
                </div>
            )
        case 'ADVCASH':
            return (
                <div>
                    <Icon icon={'ADVCASH'} color={selected ? '#404040' : ''} size={34} />
                </div>
            )
        case 'PAYEER':
            return (
                <div>
                    <Icon icon={'PAYEER'} color={selected ? '#404040' : ''} size={36} />
                </div>
            )
        case 'PERFECT_MONEY':
            return (
                <div>
                    <Icon icon={'PERFECT_MONEY'} color={selected ? '#404040' : ''} size={36} />
                </div>
            )
        case 'YANDEX_MONEY':
            return (
                <div>
                    <Icon icon={'YANDEX_MONEY'} color={selected ? '#404040' : ''} size={40} />
                </div>
            )
        case 'WEBMONEY':
            return (
                <div>
                    <Icon icon={'WEBMONEY'} color={selected ? '#404040' : ''} size={40} />
                </div>
            )
        case 'CAPITALIST':
            return (
                <div>
                    <Icon icon={'CAPITALIST'} color={selected ? '#404040' : ''} size={40} />
                </div>
            )
        default:
            return (
                <div>
                    <Icon icon={'GENERAL_PAYMENT'} color={selected ? '#404040' : ''} size={36} />
                </div>
            )
    }
}

export default Payway